/* update meta data factory */

angular.module('storyApp').factory('metaDataFactory', function() {
    
    var service = {
        
        metaData: null,

        metaObj: {

            desc: document.querySelector("meta[name='description']"),
            ogTitle: document.querySelector("meta[property='og:title']"),
            ogDescription: document.querySelector("meta[property='og:description']"),
            ogUrl: document.querySelector("meta[property='og:url']"),
            ogImage: document.querySelector("meta[property='og:image']"),
            twitterTitle: document.querySelector("meta[name='twitter:title']"),
            twitterDescription: document.querySelector("meta[name='twitter:description']"),
            twitterImage: document.querySelector("meta[name='twitter:image:src']"),
            canonicalUrl: document.querySelector("link[rel='canonical']")

        },
        
        setPageMetadata: function(metaData){
            this.metaData = metaData;
        },
        
        getPageMetadata: function(){
            return this.metaData;
        },

        getMainStoryAnalyticsMeta: function(){

            var data = {};
            var metaEl = document.querySelector('[fs-prop="analytics"]');
            var attributes = ['account', 'cms-id', 'utaglib-path', 'utags', 'page-name', 'category', 'sub-category',
                'page-type', 'page_topic', 'page-type-alias,', 'page-topic', 'user-state', 'filename', 'story-title',
                'source', 'author', 'publish-date', 'refresh-rate', 'story-position', 'hasEmbeddedGallery', 'site-name',
                'page-attribute', 'testScorestripPosition'
            ];

            for (var i = 0, l = attributes.length; i < l; i++) {
                var attr = attributes[i];
                var val = metaEl.getAttribute(attr);
                
                if (val != null) {
                    attr = (attr.indexOf('-') >= 0) ? attr.replace(/-/g, '_') : attr;
                    data[attr] = val.trim();
                }
            }
            return data;
        },

        //get meta data object from header meta data since we don't include the meta data on page load. Format as follow
        getMainStoryMetaData: function() {

            var metaData = {};

            //add page meta
            metaData.meta = {};
            metaData.meta.title = document.title;
            metaData.meta.url = (this.metaObj.canonicalUrl)? this.metaObj.canonicalUrl.href : "";
            metaData.meta.isRedirect = 'false';
            metaData.meta.canonical = metaData.meta.url;
            metaData.meta.refreshRate = 'none';

            //add og meta
            metaData.og = {};
            metaData.og.title = (this.metaObj.ogTitle)? this.metaObj.ogTitle.content : "";
            metaData.og.url = (this.metaObj.ogUrl)? this.metaObj.ogUrl.content : "";
            metaData.og.description = (this.metaObj.ogDescription)? this.metaObj.ogDescription.content : "";
            metaData.og.image = (this.metaObj.ogImage)? this.metaObj.ogImage.content : "";
            metaData.og.site_name = "FOX Sports";

            //add analytics meta
            metaData.analytics = this.getMainStoryAnalyticsMeta();

            return metaData;
            
        },
        updatePageMetadata: function(){

            try {
                var metaData = this.getPageMetadata();

                if (typeof metaData.og !== 'undefined') {

                    document.title = metaData.meta.title;
                    this.metaObj.desc.content =  metaData.og.description;
                    this.metaObj.ogTitle.content =  metaData.og.title;
                    this.metaObj.ogDescription.content = metaData.og.description;
                    this.metaObj.ogUrl.content = metaData.og.url;
                    this.metaObj.ogImage.content = metaData.og.image;
                    this.metaObj.canonicalUrl.href =  metaData.meta.canonical;

                    //twitter
                    this.metaObj.twitterTitle.content = metaData.og.title;
                    this.metaObj.twitterDescription.content = metaData.og.description;

                    if (this.metaObj.twitterImage) {
                        this.metaObj.twitterImage.content = metaData.og.image;
                    }

                }

            } catch(e) {

                console.log("UpdatePageMetadata Error: "+e.message)

            }

        },
        
        onPageChanged: function(metaData){
            
            this.setPageMetadata(metaData);
            this.updatePageMetadata();
            
        }
    };


    return service;
    
});